import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import classes from "../../App.module.css";
import imgUrl from "../../assets/images/imageUrl.js";
import CustomDrawer from "../../pages/template/CustomDrawer.js";
import Grid from "@material-ui/core/Grid";

import "../../assets/css/customstyles.css";
import "../../assets/css/theme_grey.css";
import "../../assets/css/theme_blue.css";
import "../../assets/css/theme_green.css";
import "../../assets/css/theme_red.css";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import {
  Button,
  InputFieldFF,
  ReactFinalForm,
  hasValue,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { apiServices } from "../../services/apiServices";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation, initReactI18next } from "react-i18next";
import swal from "sweetalert";

import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";

const { Form, Field } = ReactFinalForm;

function Login({ onSuccess }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [showPasswordFlag, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [resources, setResources] = React.useState({});

  useEffect(() => {
    i18n.changeLanguage("en");
    OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
      if (loginDetails.data != undefined) {
        // history.push("/layout/home")
        onSuccess();
      }
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          OfflineDb.setDataIntoPouchDB("geolocation", {
            lat: latitude,
            lng: longitude,
          });
          //alert("Geolocation R&D : "+latitude+' : '+longitude);
        },
        (error) => {
          // if geolocation denied by user then set default one
          OfflineDb.setDataIntoPouchDB("geolocation", {
            lat: 40.712742,
            lng: -74.013382,
          });
          //alert("Geolocation Error : "+error)
        }
      );
    } else {
      // if geolocation denied by user then set default one
      OfflineDb.setDataIntoPouchDB("geolocation", {
        lat: 40.712742,
        lng: -74.013382,
      });
    }
  }, []);

  function checkPinExist(userName) {
    let pinExist = false;
    if (navigator.onLine) {
      //setGlobalSpinner(true)
      apiServices
        .postAPI("save/mfa/user/check/pinexist", { username: userName })
        .then((res) => {
          if (res && res.data && res.data.status) {
            if (res.data.status == "success") {
              localStorage.setItem("pinExist", "Yes");
              localStorage.setItem("pinSet", "Yes");
              history.push("/checkPin");
              // onSuccess();
            } else if (res.data.status == "fail") {
              localStorage.setItem("pinExist", "No");
              localStorage.setItem("pinSet", "No");
              history.push("/enterToken");
            }
          } else {
            swal({
              title: t("Error 1:"),
              text: t("Sorry something went wrong, please try again later"),
              icon: "error",
              button: t("Close"),
            });
          }
          setGlobalSpinner(false);
        })
        .catch((err) => {
          setGlobalSpinner(false);
          swal({
            title: t("Error 2:"),
            text: t("Sorry something went wrong, please try again later"),
            icon: "error",
            button: t("Close"),
          });
        });
    } else {
      setGlobalSpinner(false);
      localStorage.setItem("pinExist", "Yes");
      localStorage.setItem("pinSet", "Yes");
      onSuccess();
    }
  }

  function setTransltions(resources) {
    let value = localStorage.getItem("locale");
    console.log("value", value);
    if (value) {
      i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
          resources,
          fallbackLng: "en",
          lng: value, //localStorage.getItem('locale') ? localStorage.getItem('locale'): 'en',
          keySeparator: false, // we do not use keys in form messages.welcome

          interpolation: {
            escapeValue: false, // react already safes from xss
          },
          react: {
            useSuspense: false,
            wait: false,
          },
        });
    }
  }

  function onSubmit(values) {
    //setLoading(true)
    setGlobalSpinner(true);
    const Authorization =
      "Basic " + btoa(values.username.trim() + ":" + values.password.trim());
    localStorage.setItem("basicAuth", Authorization);
    OfflineDb.setDataIntoPouchDB("basicAuth", Authorization);
    apiServices
      .loginApi(Authorization)
      .then((res) => {
        OfflineDb.setDataIntoPouchDB("loginDetails", res.data).then((a) => {
          apiServices
            .getAPI("dataStore/configuration/configuration")
            .then((res) => {
              OfflineDb.setDataIntoPouchDB("configurations", res.data);
              apiServices
                .getAPI("dataStore/translations/translations")
                .then((res) => {
                  OfflineDb.setDataIntoPouchDB("translationResource", res.data);
                  setResources(res.data);
                  setTransltions(res.data);
                  localStorage.setItem(
                    "translations",
                    JSON.stringify(res.data)
                  );
                  // apiServices
                  //   .getAPI(
                  //     "categoryOptions?filter=name:eq:" + values.username.trim()
                  //   )
                  //   .then((categoryRes) => {
                  //     OfflineDb.setDataIntoPouchDB(
                  //       "categoryOptions",
                  //       categoryRes.data
                  //     );
                      //setGlobalSpinner(false)
                      setTimeout(() => {
                        
                      if(values.username.trim() == '28333_orw1@uatpreventtb.org' || values.username.trim() == '28333_facilitytb1@uatpreventtb.org'){
                        history.push("/selectlanguage")
                      }else{
                        checkPinExist(values.username.trim()); 
                      }
                      }, 500);
                    // })
                    // .catch((error) => {
                    //   //console.log("error",error);
                    //   //setGlobalSpinner(false)
                    //   setTimeout(() => {
                    //     //history.push("/selectlanguage")
                    //     checkPinExist(values.username.trim());
                    //   }, 500);
                    // });
                })
                .catch((error) => {
                  console.log('err>>', error)
                  // apiServices
                  //   .getAPI(
                  //     "categoryOptions?filter=name:eq:" + values.username.trim()
                  //   )
                  //   .then((categoryRes) => {
                  //     OfflineDb.setDataIntoPouchDB(
                  //       "categoryOptions",
                  //       categoryRes.data
                  //     );
                      //setGlobalSpinner(false)
                      //history.push("/selectlanguage")
                      checkPinExist(values.username.trim());
                    // })
                    // .catch((error) => {
                    //   //console.log("error",error);
                    //   //setGlobalSpinner(false)
                    //   //history.push("/selectlanguage")
                    //   checkPinExist(values.username.trim());
                    // });
                });
            })
            .catch((error) => {
              setGlobalSpinner(false);
              swal({
                title: t("Error 3:"),
                text: t("Sorry something went wrong, please try again later"),
                icon: "error",
                button: t("Close"),
              });
            });
        });
      })
      .catch((error) => {
        if (error.response) {
          swal({
            title: t("Login failed"),
            text: t(error.response.data.message),
            icon: "error",
            button: t("Close"),
          });
        } else {
          swal({
            title: t("Login failed"),
            text: "",
            icon: "error",
            button: t("Close"),
          });
        }
        //setLoading(false)
        setGlobalSpinner(false);
      });
  }

  // function onSubmit(values) {
  //     //setLoading(true)
  //     setGlobalSpinner(true)
  //     const Authorization = 'Basic ' + btoa(values.username.trim() + ":" + values.password.trim())
  //     localStorage.setItem('basicAuth', Authorization)
  //     OfflineDb.setDataIntoPouchDB('basicAuth', Authorization)
  //     apiServices.loginApi(Authorization).then(res => {
  //         OfflineDb.setDataIntoPouchDB('loginDetails', res.data)
  //             .then(a => {
  //                 apiServices.getAPI('dataStore/configuration/configuration').then(res=>{
  //                     OfflineDb.setDataIntoPouchDB('configurations',res.data)
  //                     setGlobalSpinner(false)
  //                     setTimeout(()=>{
  //                         history.push("/selectlanguage")
  //                         // checkPinExist(values.username.trim())
  //                     },500)

  //                 }).catch(error => {
  //                     setGlobalSpinner(false)
  //                     history.push("/selectlanguage")
  //                     // checkPinExist(values.username.trim())
  //                 })
  //             })

  //     }).catch(error => {
  //         if (error.response) {

  //             swal({
  //                 title: "Login failed",
  //                 text: error.response.data.message,
  //                 icon: "error",
  //                 button: "Close",
  //             });
  //         } else {
  //             swal({
  //                 title: "Login failed",
  //                 text: "",
  //                 icon: "error",
  //                 button: "Close",
  //             });
  //         }
  //         //setLoading(false)
  //         setGlobalSpinner(false)
  //     })
  // }

  function doForgotPasswordRecoveryCall(username) {
    var bodyFormData = new FormData();
    bodyFormData.append("username", username);
    const url = "account/recovery";
    setLoading(true);
    apiServices
      .postMultiPartFormDataAPI(url, bodyFormData)
      .then((res) => {
        setLoading(false);
        swal({
          title: "Done",
          text: res.data.message,
          icon: "success",
          button: "Close",
        });
      })
      .catch((err) => {
        if (err.response) {
          swal({
            title: "Fail",
            text: err.response.data.message,
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  }

  function openForgotPasswordPopup() {
    swal({
      text: "Please enter username",
      content: "input",
      buttons: ["Cancel", "Submit"],
    }).then((username) => {
      if (username) {
        doForgotPasswordRecoveryCall(username);
      }
    });
  }

  function showPassword() {
    if (showPasswordFlag) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  }
  const regex = new RegExp("^[a-zA-Z0-9_@.]*$");
  const scriptBlockRegex = new RegExp("/<[^>]*>/g");
  const passwordRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const required = (value) => (value ? undefined : "Required");
  const userCheck = (value) =>
    value
      ? value.match(regex) != null
        ? undefined
        : "Incorrect expression added as input"
      : undefined;
  const scriptCheck = (value) =>
    value
      ? value.match(scriptBlockRegex) != null
        ? 'Incorrect expression "< or >" added as input'
        : undefined
      : undefined;
  const passWordCheck = (value) =>
    value
      ? value.match(passwordRegex) != null
        ? undefined
        : "Incorrect password pattern"
      : undefined;
  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  return (
    <div className={classes.container}>
      <main style={{ display: "flex", height: "100%", width: "100%" }}>
        <section
          lassName="mainsection pb-0"
          style={{
            flexGrow: 1,
            padding: 12,
          }}
        >
          <Grid container spacing={3} className="">
            <Grid item xs={12} sm={12} md={12} className="loginpageformholder">
              <div className="innerdiv">
                <p className="zero text-center">
                  <div className="useravtarimg" />
                </p>
                <p className="zero text-center">
                  <h3 className="text-uppercase">Sign In</h3>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} className="pagelaterpart">
              <div class="custom-shape-divider-top-1612935135">
                <svg
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1200 120"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                    class="shape-fill"
                  ></path>
                </svg>
              </div>
              <div className="loginpageformholder">
                {/* <p className="loginformheading">Sign In</p> */}
                {loading ? (
                  <CenteredContent
                    dataTest="dhis2-uicore-centeredcontent"
                    position="middle"
                  >
                    <CircularLoader
                      large
                      dataTest="dhis2-uicore-circularloader"
                    />
                  </CenteredContent>
                ) : (
                  ""
                )}
                <Form
                  autocomplete="off"
                  onSubmit={(values) => onSubmit(values, null, 2)}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                  }) => (
                    <form
                      onSubmit={handleSubmit}
                      autocomplete="off"
                      style={{ display: "contents" }}
                    >
                      <div className="w-100">
                        <Field
                          name="username"
                          label="User Name"
                          component={InputFieldFF}
                          key="username"
                          validate={composeValidators(
                            required,
                            userCheck,
                            scriptCheck
                          )}
                          required
                        />
                      </div>
                      <div className="w-100">
                        <Field
                          name="password"
                          label="Password"
                          component={InputFieldFF}
                          key="password"
                          validate={composeValidators(
                            required,
                            scriptCheck,
                            passWordCheck
                          )}
                          required
                          className={showPasswordFlag ? "" : "password"}
                        />
                        <p className="visibilityiconcontainer">
                          {!showPasswordFlag ? (
                            <VisibilityIcon onClick={() => showPassword()} />
                          ) : (
                            <VisibilityOffIcon onClick={() => showPassword()} />
                          )}
                        </p>
                      </div>
                      <p
                        className="forgotpw"
                        style={{ cursor: "pointer" }}
                        onClick={() => openForgotPasswordPopup()}
                      >
                        Forgot Password?
                      </p>
                      <div className="buttons">
                        <Button
                          type="submit"
                          disabled={submitting}
                          className="loginbtn loginsubmitbtn"
                        >
                          Login
                        </Button>
                        &nbsp;
                        <Button
                          type="button"
                          onClick={form.reset}
                          disabled={submitting || pristine}
                          className="resetButton"
                        >
                          Reset
                        </Button>
                      </div>
                    </form>
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </section>
      </main>
    </div>
  );
}

export default Login;
